/**
 * Toast Hook
 * Module 07 - Dashboard UI
 * 
 * Hook for displaying toast notifications
 */

import { useContext } from 'react';
import { ToastContext } from '../contexts/ToastContext';

/**
 * Hook to show toast notifications
 * Must be used within ToastProvider
 * 
 * @returns Toast context methods
 * 
 * @example
 * const { showToast } = useToast();
 * showToast('success', 'Model uploaded successfully!');
 * showToast('error', 'Failed to delete embed');
 */
export function useToast() {
  const context = useContext(ToastContext);
  
  if (!context) {
    throw new Error('useToast must be used within ToastProvider');
  }
  
  return context;
}
